import React, { Component } from 'react'
import FlipMove from 'react-flip-move'
import Checkbox from 'components/input/checkbox'
import ProfilePicture from 'components/profile/profile-picture'

import { isMobile } from 'utils'
import SearchMini from 'components/search-mini/search-mini'

export default class GuestList extends Component {
	state = {
		searchTerm: ''
	}

	handleChange = searchTerm => {
		this.setState({
			searchTerm
		})
	}

	render() {
		const {
			users,
			includedKeyArrays,
			checkKeys,
			handleChangeUsers,
			removeUser,
			parentEntityId,
			hasRoles,
			hasSearch,
			isTeams,
			accountData,
			isPublic,
			canSelect,
			isGuest,
			isProjects
		} = this.props

		const {
			searchTerm
		} = this.state

		const lowercaseSearchTerm = searchTerm.toLowerCase()

		let guestListClass = 'guest-list'

		if (hasRoles) {
			guestListClass += ' with-roles'
		}

		if (hasSearch) {
			guestListClass += ' with-search'
		}

		if (isTeams) {
			guestListClass += ' is-teams'
		}

		const dedupedUsers = users.filter(((item, index) => {
			if(item.email){
				return true
			}

			if(item.recipient_email){
				const exists = users.find(_item => _item.email === item.recipient_email)

				if(exists){
					return false
				}
			}

			return true
		}))

		return (
			<div>
				{ hasRoles &&
					<div className="guest-list-controls">
						<label>
							Member
						</label>
						<label>
							Admin
						</label>
						<SearchMini
							searchTerm={searchTerm}
							onSearchTermChange={this.handleChange}
						/>
					</div>
				}
				<ul className={guestListClass}>
					<FlipMove
						duration={200}
						easing="ease-out"
						enterAnimation="accordionVertical"
						leaveAnimation="accordionVertical"
					>
						{isTeams &&
							<li className={isPublic ? "active" : null}>
								<label>
									<Checkbox
										isChecked={isPublic}
										onChange={_ => {
											if (canSelect) {
												handleChangeUsers(null)
											}
										}}
									/>
									<span className="user-name">
										Public
									<em>
											(Everyone at {accountData.name})
									</em>
									</span>
								</label>
							</li>
						}
						{dedupedUsers.map(user => {
							let isAtLeastOneChecked = false

							if (lowercaseSearchTerm) {
								if (!user.first_name.toLowerCase().includes(lowercaseSearchTerm) && !user.last_name.toLowerCase().includes(lowercaseSearchTerm) && !user.email.toLowerCase().includes(lowercaseSearchTerm)) {
									return null
								}
							}

							let email = null

							checkKeys.forEach(key => {
								if (user[key]) {
									email = user[key]
								}
							})

							let isCheckedArray = []

							includedKeyArrays.forEach(includedKeys => {
								if (includedKeys.indexOf(email) !== -1) {
									isAtLeastOneChecked = true
									isCheckedArray.push(true)
								} else {
									isCheckedArray.push(false)
								}
							})

							let className = isAtLeastOneChecked ? 'active' : ''

							if (!canSelect) {
								className += ' block-click'
							}

							let isNewOrOnlyOnThisProject = false

							if (isGuest) {
								isNewOrOnlyOnThisProject = !user.first_name && (user.email || (user.projectIds.length == 1 && user.projectIds[0] == parentEntityId))

								if (isNewOrOnlyOnThisProject) {
									className += ' has-remove'
								}
							}

							const isUnconfirmed = user.recipient_email || !user.id

							const userEmail = user.email ? user.email : user.recipient_email

							return (
								<li key={email} className={className}>
									<label onClick={e => {
										e.preventDefault()
										handleChangeUsers(user, 0)
									}}>
										{isCheckedArray.map((isChecked, index) => {
											return (
												<Checkbox
													key={index}
													isChecked={isChecked}
													onChange={_ => { handleChangeUsers(user, index) }}
													ignoreLabel={hasRoles}
												/>
											)
										})}
										{(!isProjects && !isTeams) &&
											<ProfilePicture user={user} isTiny={true} />
										}
										{isTeams &&
											<span className="user-name">
												{user.name}
												<em>
													{user.userIds.length} {user.userIds.length == 1 ? 'user' : 'users'}
												</em>
											</span>
										}
										{(!isTeams && !isProjects) &&
											<span className="user-name">
												{user.first_name ?
													user.first_name + ' ' + user.last_name
													: null}
												{isMobile() && !user.first_name ?
													' (Unconfirmed guest)'
													: null}
												<em>
													{userEmail}
													{(!isMobile() && isUnconfirmed) ?
														' (unconfirmed)'
														: null}
												</em>
											</span>
										}
										{isProjects &&
											<span className="project-name">
												{user.name}
											</span>
										}
										{
											isNewOrOnlyOnThisProject ?
												<button onClick={_ => { removeUser(user) }}>
													&times;
											</button>
												:
												null
										}
									</label>
								</li>

							)
						})
						}
					</FlipMove>
				</ul>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/modal/modal-components/guest-list.jsx